import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const newsletterApi = createApi({
    reducerPath: "newsletterApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["Subscribers"],
    endpoints: (builder) => ({
        subscribeToNewsletter: builder.mutation({
            query: (data) => ({
                url: "newsletter/subscribe",
                method: "POST",
                body: data,
            }),
        }),
        unsubscribeFromNewsletter: builder.mutation({
            query: (data) => ({
                url: "newsletter/unsubscribe",
                method: "POST",
                body: data,
            }),
        }),
        getAllSubscribers: builder.query({
            query: (params) => ({
                url: "newsletter/subscribers",
                params,
            }),
            providesTags: ["Subscribers"],
        }),
    }),
});

export const {
    useSubscribeToNewsletterMutation,
    useUnsubscribeFromNewsletterMutation,
    useGetAllSubscribersQuery,
} = newsletterApi;
